const ENVIRONMENTS = Object.freeze({
    DEVELOPMENT: "development",
    STAGING: "staging",
    PRODUCTION: "production",
});

const API_BASE_ROUTE = Object.freeze({
    DEVELOPMENT: "https://bs360-dev-apim.azure-api.net",
    STAGING: "https://bs360-stag-apim.azure-api.net",
    PRODUCTION: "https://bs360-prod-apim.azure-api.net",
});

const getBaseUrl = () => {
    const env = process.env.NEXT_PUBLIC_APP_ENV;
    if (env === ENVIRONMENTS.PRODUCTION) return API_BASE_ROUTE.PRODUCTION;
    if (env === ENVIRONMENTS.STAGING) return API_BASE_ROUTE.STAGING;
    return API_BASE_ROUTE.DEVELOPMENT;
};

const HUB_PROXIES = [
    {
        clientPath: "/api/announcements-hub",
        upstreamPath:
            "/notification-management-ws-announcements/hub/announcements",
    },
];

module.exports = { ENVIRONMENTS, API_BASE_ROUTE, getBaseUrl, HUB_PROXIES };
